export const shortenLine = (line: string, max: number = 95) => {
  if (line.length <= max) {
    return line;
  }

  const slice = line.slice(0, max);
  const lastSpace = slice.lastIndexOf(' ');

  if (lastSpace === -1) {
    return `${slice.trim()}...`;
  }

  return `${slice.slice(0, lastSpace).trim()}...`;
};
